import * as TYPE from "./type";

import FactoryService from "@/services/FactoryService";

const moduleCryptoRegistration = {
	namespaced: true,
	state: {
		myNumberStatus: null,
		cryptoMailConfirmScript: null
	},
	mutations: {
		updateMyNumberStatus(state, myNumberStatus) {
			state.myNumberStatus = myNumberStatus;
		},
		updateCryptoMailConfirmScript(state, cryptoMailConfirmScript){
			state.cryptoMailConfirmScript = cryptoMailConfirmScript;
		}
	},
	actions: {
		async [TYPE.INIT_CRYPTO_REGISTRATION_FLAGS]({ state, commit }) {
			let service = FactoryService.getService("cryptoRegistration");

			if (!state.myNumberStatus || !state.cryptoMailConfirmScript) {
				const data = await service.getMyNumberStatusAndCorpType();
				commit('updateMyNumberStatus', data.myNumberStatus);
				commit('updateCryptoMailConfirmScript', data.cryptoMailConfirmScript);
			}
		}
	}
};
export default moduleCryptoRegistration;
